import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {PageUser} from '../index';
import {environment} from '@Env/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Gestionnaire} from './gestionnaire.model';


@Injectable({
  providedIn: 'root'
})
export class GestionnairesService extends DaoGeneric<PageUser> {
  private url = `${environment.baseUrl}/api_bdc/pageuser/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }

  /**
   * Recherche les gestionnaires BDC (search=xyz&role=gestionnaire_bdc)
   * @param val la chaine de recherche (prénom nom)
   * @return une liste Gestionnaire (RoleEntite) trouvés
   */
  searchGestionnaire(val): Observable<Gestionnaire[]> {
    if (val) {
      const url = `${environment.baseUrl}/api_bdc/search_gestionnaires/`;
      let urlQS = new HttpParams();
      urlQS = urlQS.set('search', val).set('role', 'gestionnaire_bdc');

      return this.httpClient.get<Gestionnaire[]>(url, {params: urlQS});
    }
  }
}
